import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=1655489c&scoped=true&"
var script = {}
import style0 from "./Cookies.vue?vue&type=style&index=0&id=1655489c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1655489c",
  null
  
)

export default component.exports